import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    tarjetaPlasticoId: 0,
    tarjetaPlastico: null,
    tarjetaPlasticoNombre: null,
    loteNumero: '',
    cuponNumero: '',
    fechaCupon: moment(new Date()).format('YYYY-MM-DD'),
    cuotas: 0,
    monedaId: 0,
    moneda: null,
    monedaNombre: null,
    importe: 0,
    rowVersion: null,
    
    tarjetaCuponDatos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_TARJETA_CUPON'(state, tarjetaCuponId) {
        state.id = tarjetaCuponId;
        state.tarjetaPlasticoId = 0;
        state.tarjetaPlastico = null;
        state.tarjetaPlasticoNombre = null;
        state.loteNumero = '';
        state.cuponNumero = '';
        state.fechaCupon = moment(new Date()).format('YYYY-MM-DD');
        state.cuotas = 0;
        state.monedaId = 0;
        state.moneda = null;
        state.monedaNombre = null;
        state.importe = 0;
        state.rowVersion = null;
    },
    'SET_TARJETA_CUPON'(state, tarjetaCupon) {
        state.tarjetaPlasticoId = (tarjetaCupon.tarjetaPlastico) ? tarjetaCupon.tarjetaPlastico.id : 0;
        state.tarjetaPlastico = tarjetaCupon.tarjetaPlastico;
        state.tarjetaPlasticoNombre = (tarjetaCupon.tarjetaPlastico) ? tarjetaCupon.tarjetaPlastico.nombre.trim() : null;
        state.loteNumero = tarjetaCupon.loteNumero.trim();
        state.cuponNumero = tarjetaCupon.cuponNumero.trim();
        state.fechaCupon = moment(tarjetaCupon.fechaCupon).format('YYYY-MM-DD');
        state.cuotas = tarjetaCupon.cuotas;
        state.monedaId = (tarjetaCupon.moneda) ? tarjetaCupon.moneda.id : 0;
        state.moneda = tarjetaCupon.moneda;
        state.monedaNombre = (tarjetaCupon.moneda) ? tarjetaCupon.moneda.nombre.trim() : null;
        state.importe = tarjetaCupon.importe;
        state.rowVersion = tarjetaCupon.rowVersion;
    },
    'SET_TARJETA_PLASTICO'(state, tarjetaPlastico) {
        state.tarjetaPlastico = tarjetaPlastico;
        if (tarjetaPlastico) {
            state.tarjetaPlasticoId = tarjetaPlastico.id ? tarjetaPlastico.id : 0;
            state.tarjetaPlasticoNombre = tarjetaPlastico.nombre ? tarjetaPlastico.nombre.trim() : null;
        } else {
            state.tarjetaPlasticoId = 0;
            state.tarjetaPlasticoNombre = null;
        }
    },
    'SET_MONEDA'(state, moneda) {
        state.moneda = moneda;
        if (moneda) {
            state.monedaId = moneda.id ? moneda.id : 0;
            state.monedaNombre = moneda.nombre ? moneda.nombre.trim() : null;
        } else {
            state.monedaId = 0;
            state.monedaNombre = null;
        }
    },

    'INICIALIZAR_TARJETA_CUPON_DATOS' (state) {
        state.tarjetaCuponDatos = [];
    },
    'SET_TARJETA_CUPON_DATOS' (state, params) {
        state.tarjetaCuponDatos = params.tarjetaCuponDatos;
    }
};

const getters = {
    getField,

    tarjetaCupon (state) {
        let tarjetaCupon = {
            tarjetaPlasticoId: parseInt(state.tarjetaPlasticoId),
            monedaId: parseInt(state.monedaId),
            moneda: state.monedaNombre,
            loteNumero: state.loteNumero.toUpperCase().trim(),
            cuponNumero: state.cuponNumero.toUpperCase().trim(),
            fechaCupon: moment(state.fechaCupon).format('YYYY-MM-DD'),
            cuotas: parseInt(state.cuotas),
            importe: parseFloat(state.importe),
        }
        return tarjetaCupon;
    }
};

const actions = {
    inicializar ( { commit }, tarjetaCuponId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_TARJETA_CUPON', tarjetaCuponId);

            if (tarjetaCuponId) {
                if (tarjetaCuponId != 0) {
                    apiAxios.get(`tarjetascupones/${tarjetaCuponId}/abm` ) 
                        .then(res => {
                            commit('SET_TARJETA_CUPON', res.data);
                            resolve();
                        })
                        .catch(error => reject(helpers.methods.getErrorMessage(error)));
                } else {
                    resolve();
                }
            } else {
                resolve();
            }
        }, error => {
            reject(error);
        })
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            // (/true/i).test(state.bancoMovimientoTipo.credito)
            let tarjetaCupon = {
                tarjetaPlasticoId: parseInt(state.tarjetaPlasticoId),
                monedaId: parseInt(state.monedaId),
                loteNumero: state.loteNumero.toUpperCase().trim(),
                cuponNumero: state.cuponNumero.toUpperCase().trim(),
                fechaCupon: moment(state.fechaCupon).format('YYYY-MM-DD'),
                cuotas: parseInt(state.cuotas),
                importe: parseFloat(state.importe),
            }
    
            let url = 'tarjetascupones';
            if (state.id != 0) {
                tarjetaCupon.rowVersion = state.rowVersion;
                url += '/' + state.id;
            }

            apiAxios.post(url, tarjetaCupon)
                .then(() => {
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    setTarjetaPlastico: ({commit}, tarjetaPlastico) => {
        commit('SET_TARJETA_PLASTICO', tarjetaPlastico);
    },
    setMoneda: ({commit}, moneda) => {
        commit('SET_MONEDA', moneda);
    },

    getTarjetaCuponDatos ( { commit }, tarjetaCuponId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_TARJETA_CUPON_DATOS');

            if (tarjetaCuponId != 0) {
                apiAxios.get('tarjetascupones/' + tarjetaCuponId ) 
                .then(res => {
                    let importe = helpers.methods.formattedMoneda(res.data.importe, res.data.moneda);

                    let tarjetaCuponDatos = [
                        { 'nombre': 'tarjeta', 'campo': 'Tarjeta', 'valor': res.data.tarjeta, 'formato': '' },
                        { 'nombre': 'proveedor', 'campo': 'Proveedor', 'valor': res.data.proveedor, 'formato': '' },
                        { 'nombre': 'loteNumero', 'campo': 'Lote', 'valor': res.data.loteNumero, 'formato': '' },
                        { 'nombre': 'cuponNumero', 'campo': 'Cupón', 'valor': res.data.cuponNumero, 'formato': 'cuit' },
                        { 'nombre': 'fechaCupon', 'campo': 'Fecha', 'valor': res.data.fechaCupon, 'formato': 'fecha' },
                        { 'nombre': 'cuotas', 'campo': 'Cuotas', 'valor': res.data.cuotas, 'formato': '' },
                        { 'nombre': 'importe', 'campo': 'Importe', 'valor': importe, 'formato': '' },
                        { 'nombre': 'referencia', 'campo': 'Referencia', 'valor': res.data.referencia, 'formato': '' },
                    ];
                    
                    let params = {
                        tarjetaCuponDatos 
                    }
                    commit('SET_TARJETA_CUPON_DATOS', params);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
            
        }, error => {
            reject(error);
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}